import { useQuery } from '@tanstack/react-query';

import { requestEventRemainCount } from './index';

export const MAPPED_EVENT_LIMIT_QUERY_KEY = 'MAPPED_EVENT_LIMIT_QUERY_KEY';

export const useMappedEventLimit = () => {
  return useQuery([MAPPED_EVENT_LIMIT_QUERY_KEY], async () => {
    const res = await requestEventRemainCount();
    return res?.data;
  });
};
